// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2TthQ","addWidgetButton":"Header_addWidgetButton__3o4TT","dashboardTabs":"Header_dashboardTabs__-s7F_","active":"Header_active__3qx9l"};